"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,14.4c-0.3,0-0.5-0.2-0.5-0.5V4c0-0.3,0.2-0.5,0.5-0.5S13,3.8,13,4v9.8C13,14.1,12.8,14.4,12.5,14.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.8,9.9c-0.1,0-0.2,0-0.3-0.1C7.3,9.6,7.2,9.2,7.4,9l4.7-5.3c0.2-0.2,0.6-0.2,0.8,0L17.6,9c0.2,0.2,0.2,0.5,0,0.7 c-0.2,0.2-0.5,0.2-0.7,0l-4.3-4.9L8.2,9.7C8.1,9.8,7.9,9.9,7.8,9.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,21.5c-0.3,0-0.5-0.2-0.5-0.5v-9.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V21C13,21.2,12.8,21.5,12.5,21.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,21.5L12.5,21.5c-0.1,0-0.3-0.1-0.4-0.2L7.4,16c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l4.3,4.9l4.3-4.9 c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-4.7,5.3C12.8,21.4,12.6,21.5,12.5,21.5z"
  }));
};

exports["default"] = _default;